<template>
  <div id="app" :class="[user ? 'user-back' : '']">
    <Header
      :active="active"
      :ActiveClick="ActiveClick"
      :headerColor="headerColor"
      :detail="detail"
      v-if="!login"
    ></Header>
    <div id="nav"></div>
    <router-view />
    <Footer v-if="!login"></Footer>
  </div>
</template>

<script>
import "@/assets/css/web.css";
import "@/assets/css/webViews.css";
import "@/assets/css/webMax.css";
import Footer from "./views/footer.vue";
import Header from "@/views/header.vue";
import Api from "@/apis";
// import "@/assets/js/index.js";
export default {
  data() {
    return {
      user: false,
      headerColor: "nav-header-white",
      active: "",
      detailColor: true,
      detail: true,
      phoneActive: "",
      login: false
    };
  },
  watch: {
    $route: "headerChange"
  },
  mounted() {
    this.headerChange();
    this.setSettings();
  },
  components: {
    Header,
    Footer
  },
  methods: {
    async setSettings() {
      const setting = await Api.Setting.getSettings();
      localStorage.setItem("settings", JSON.stringify(setting));
    },
    headerChange() {
      const routers = this.$route.path;
      if (routers.indexOf("user") > -1) {
        this.user = true;
        this.active = "user";
      } else {
        this.user = false;
      }
      if (routers.indexOf("login") > -1) {
        this.login = true;
      } else {
        this.login = false;
      }
      if (routers.indexOf("about") > -1) {
        this.active = "about";
      } else if (routers.indexOf("product") > -1) {
        this.active = "product";
        if (routers.indexOf("diligence") > -1) {
          this.phoneActive = "diligence";
        } else if (routers.indexOf("it") > -1) {
          this.phoneActive = "it";
        } else if (routers.indexOf("digital") > -1) {
          this.phoneActive = "digital";
        } else {
          this.phoneActive = "";
        }
      } else if (routers.indexOf("solution") > -1) {
        this.active = "solution";
      } else if (routers.indexOf("new") > -1) {
        this.active = "new";
      } else if (routers.indexOf("user") > -1) {
        this.active = "user";
      } else {
        this.active = "home";
      }
      if (
        routers.indexOf("details") > -1 ||
        routers.indexOf("projectDetails") > -1 ||
        routers.indexOf("product/list") > -1 ||
        routers.indexOf("user") > -1
      ) {
        this.headerColor = "nav-header-black";
        this.detail = false;
      } else {
        this.headerColor = "nav-header-white";
        this.detail = true;
      }
    },
    ActiveClick(value) {
      this.active = value;
    }
  }
};
</script>
<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
.carousels .carousel-indicators {
  li {
    outline: none !important;
  }
}
#app {
  max-width: 100%;
  overflow-x: hidden;
}
</style>
